export default {
  serviceList: {items: [], _links: {}, _meta: {}},
  categoryList: {items: [], _links: {}, _meta: {}},
  allCategoryList: [],
  fullCategoryServiceList: [],
  activeStaffData: {

  },
  activeServiceData: {

  },
  checkoutServiceData: {items: [], _links: {}, _meta: {}},
  checkoutService: [],
  categoryListAll: {items: [], _links: {}, _meta: {}},
  service_info: {},
  categoryListByType: {items: [], _links: {}, _meta: {}},
  serviceListByType: {items: [], _links: {}, _meta: {}},
  productListByType: [],
  comboListByType: {items: [], _links: {}, _meta: {}},

  giftCardData: {items: [], _links: {}, _meta: {}},
  giftCardDetail: {},
  comboListActive: {items: [], _links: {}, _meta: {}}, //to check whether service in any combo or not
}
